import { render, staticRenderFns } from "./firmSign.vue?vue&type=template&id=54dd8827&scoped=true"
import script from "./firmSign.vue?vue&type=script&lang=js"
export * from "./firmSign.vue?vue&type=script&lang=js"
import style0 from "./firmSign.vue?vue&type=style&index=0&id=54dd8827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd8827",
  null
  
)

export default component.exports